import { Button } from '@shared/ui/button/button';
import { IconMessage } from '@tabler/icons-react';
import { useStartChat } from '../model/use-start-chat';

export const StartChatButton = ({
  teacherId,
  theme = 'secondary',
  className,
  size,
}) => {
  const { startChat, isCreating } = useStartChat();

  return (
    <Button
      className={className}
      theme={theme}
      fetching={isCreating}
      disabled={isCreating}
      label="Написать"
      lefticon={<IconMessage size={size === 'small' ? 14 : 16} />}
      onClick={() => startChat(teacherId)}
      size={size}
    />
  );
};
